module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dawn-input-tooltip"
  }, [_c('p', {
    staticClass: "dawn-input-tooltip-header"
  }, [_vm._v(_vm._s(_vm.helptipHeaderMsg))]), _c('p', {
    staticClass: "dawn-input-tooltip-body"
  }, [_vm._v(_vm._s(_vm.helptipBody))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60f3ed0e","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/core/components/edInputTooltip/index.vue
// module id = BBmg
// module chunks = 13 14